<template>
  <div class="app-head clearfix">
    <div class="haveVideoBase" v-show="$route.name==='Index'" >
       <el-select v-model="videoBaseId" placeholder="请选择" @change="changeHaveVideoBase" class="selectas">
        <el-option
          v-for="(item,index) in haveVideoBaseList"
          :key="index"
          :label="item.value"
          :value="item.key">
        </el-option>
      </el-select>
    </div>
    <div class="tab-equitment" :class="{haveBase:$route.name==='Index'}" v-if="isEquipment">
      <a href="javascript:;" :class="{active:equipmentId == item.id}" v-for="(item,index) in equipmentList" :key="index" @click="tabEquipment(item.id)">
        <!-- <img :src="item.online== false? '/images/lamp_off.png':'/images/lamp_on.png'"/>{{item.name}}
        <img v-if="item.online" style="margin-right:-2px;margin-left:2px;margin-top:-2px;" :src="item.online === true&&item.powerStatus==1? '/images/Battery.png':'/images/icon_chazuoduandian.png'"/> -->
        <img :src="'/images/Electric'+item.powerStatus+'.png'">{{item.name}}
      </a>
    </div>
    <el-button type="primary" @click="addEquipment" v-if="checkadd">添加</el-button>
    <div class="set-refresh">
      <router-link tag="span" to="/paramsSeeting" v-if="isEquipment">
        <img v-if="'555'" src="../../../public/images/icon_set.png" alt="">
      </router-link>
      <img   @click="refresh" class='fresh' :class="[{refresh:fresh},{noClick:noClick}]" src="../../../public/images/icon_refresh.png" alt="">
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import indexModule from '../../store/modules/index'
import equipmentSocketModule from '../../store/modules/equipmentSocket'

export default {
  name: 'AppHead',
  data () {
    return {
      noClick: false,
      checkadd: false,
      isEquipment: true,
      isIndex: false,
      fresh: false,
      equipmentSocketList: {},
      haveVideoBaseList: [],
      videoBaseId: ''
    }
  },
  async mounted () {
    setInterval(async () => {
      console.log(888)
      await this.getEquipmentList()
    }, 30000)
    let list = await this.getHaveVideoBase()
    this.haveVideoBaseList = [
      {
        key: '',
        value: '全部'
      }
    ].concat(list)
    console.log(this.haveVideoBaseList)

    if (this.haveVideoBaseList.length > 0) {
      this.videoBaseId = this.haveVideoBaseList[0].key
      this.setHaveVideoBaseId(this.videoBaseId)
    }
    if (this.$route.path === '/deviceSettings') {
      this.isEquipment = false
      this.checkadd = true
    } else {
      this.checkadd = false
      this.isEquipment = true
    }
    this.bus.$on('checkPath', (bollean) => {
      this.checkadd = !bollean
      this.isEquipment = bollean
    })
    await this.getEquipmentList()
    if (this.equipmentList.length > 0) {
      let firstItemId = this.equipmentList[0].id
      this.setSelectedEquipmentId(firstItemId)
    }
  },
  computed: {
    ...mapState(indexModule, {
      equipmentId: 'equipmentId',
      equipmentList: 'equipmentList'
    }),
    ...mapState(indexModule, ['videoMonitor'])
  },
  methods: {
    ...mapActions(equipmentSocketModule, ['getEquipmentSocket']),
    ...mapActions(indexModule, ['getEquipmentList']),
    ...mapMutations(indexModule, ['setSelectedEquipmentId']),
    ...mapActions(indexModule, ['getHaveVideoBase']),
    ...mapMutations(indexModule, ['setHaveVideoBaseId']),
    async refresh () {
      this.fresh = true

      if (this.$route.name === 'Index') {
        this.noClick = true
        await this.getEquipmentSocket({
          id: this.equipmentId,
          isGetRealTimeData: true
        }).then(async () => {
          this.noClick = false
          setTimeout(() => {
            this.fresh = false
          }, 300)
          await this.getEquipmentList()
        }).catch(() => {
          this.noClick = false
          this.fresh = false
        })
      } else {
        setTimeout(() => {
          this.fresh = false
        }, 300)
      }
    },
    addEquipment () {
      this.bus.$emit('addOneEquipment', '父子间通讯')
    },
    tabEquipment (index) {
      // 水质参数详情页,当切换时，去除url 参数
      if (this.$route.name === 'WaterParameterDetail') {
        this.$router.replace('/waterParameterDetail')
      }
      this.setSelectedEquipmentId(index)
    },
    changeHaveVideoBase (baseId) {
      this.setHaveVideoBaseId(baseId)
    }
  },
  watch: {
    equipmentId (value) {
      if (this.equipmentId) {
        this.getEquipmentSocket({
          id: this.equipmentId,
          isGetRealTimeData: false
        })
      }
    }
  }
}
</script>
<style lang="stylus">
  .haveVideoBase
    margin-top:1.5px;
    float: left;
    .el-select .el-input.is-focus .el-input__inner {
      border-color: transparent !important ;
    }
    .el-icon-arrow-up:before {
      content: "";
    }
    .el-select
      .el-input
        max-width:190px
        height:44px!important;
        box-sizing: border-box;
        position relative
        // .el-select .el-input .el-select__caret.is-reverse{
        //   background: url('../../../public/images/baseDown.png') no-repeat
        //   background-size 100% 100%;
        // }
        .el-input__icon{
          position absolute;
          top:27px;
          right 10px
          background: url('../../../public/images/baseDown.png') no-repeat
          background-size 100% 100%;
          line-height: 40px;
          width:18px;
          height:10px;
        }
        .el-input__inner
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          font-size 18px;
          font-weight 500;
          height:44px!important;
          border:2px transparent solid;
          border-radius:4px;
          background: url('../../../public/images/btn.png') no-repeat
          background-size 100% 100%;

</style>

<style lang="stylus" scoped>
.app-head {
  padding: 0 25px;
  border-bottom: 1px solid #0e59b7;
  border-image: linear-gradient(90deg, rgba(0, 198, 255, 0.2), rgba(0, 84, 255, 0.2)) 30 30;
  line-height: 64px;
  color: white;
  background: rgba(0, 46, 115, 0.3);

}

a {
  display inline-block
  padding-right: 16px;
  // border: 1px solid #0046B0;
  border-radius: 4px;
  list-style: none;
  min-width 80px
  line-height: 42px;
  height 44px;
  margin-right: 10px;
  padding-left 16px;
  vertical-align -3px;
  font-size:16px;
  color: #728BA1;
  background: url('../../../public/images/equipment_nor.png') no-repeat
  background-size 100% 100%;
}
a img{
  margin-right 6px;
}

.active {
  border: none;
  color white
  height 44px;
  background: url('../../../public/images/equipment_sel_1.png') no-repeat
  background-size 100% 100%;
  // background-position center

}

.tab-equitment {
  float: left;
}
.haveBase{
  margin-left:10px;
}

.set-refresh {
  float: right;

  img {
    width: 32px;
    height: 32px;
    margin-left: 20px;
    cursor: pointer;
    // transition: All 0.4s ease-in-out;
    // -webkit-transition: All 0.4s ease-in-out;
    // -moz-transition: All 0.4s ease-in-out;
    // -o-transition: All 0.4s ease-in-out;
    // animation: rotate 0.5s linear;
  }
  .refresh{
      animation: rotate 0.4s infinite linear;
  }

  @keyframes rotate{
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(360deg);
    }
  }

  // .refresh {
  //   transform: rotate(360deg);
  //   -webkit-transform: rotate(360deg);
  //   -moz-transform: rotate(360deg);
  //   -o-transform: rotate(360deg);
  //   -ms-transform: rotate(360deg);

  // }
  .noClick{
    pointer-events: none;
  }
}
</style>
